module.exports = __webpack_public_path__ + "media/PAG73-03.5d2d873f.mp3";